export default "<app-missions-list></app-missions-list>";